import React from "react"
import { Surface } from "components/Surface"

export class ErrorBoundary extends React.Component<
  { t: (k: string) => string },
  { hasError: boolean }
> {
  constructor(props: Readonly<{ t: (k: string) => string }>) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    const { t } = this.props
    if (this.state.hasError) {
      return (
        <Surface
          variant="ghost"
          display="grid"
          gridAutoFlow="column"
          gridColumnGap="1rem"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
          color="var(--red)"
        >
          {" "}
          <span role="img" aria-label={t("something.went.wrong")}>
            🙁
          </span>{" "}
          {t("something.went.wrong")}
        </Surface>
      )
    }

    return this.props.children
  }
}
